module.exports = __webpack_public_path__ + "static/media/pollutiondefenseampoules.64aee38e.png";